import { API_BASE_URL } from './config';

// api/apiService.js
const apiService = {
    async getCategories() {
      const response = await fetch(`${API_BASE_URL}/categories`);
      return response.json();
    },
  
    async getItemsByCategory(categoryId) {
      const response = await fetch(`${API_BASE_URL}/items/category/${categoryId}`);
      return response.json();
    },
  
    async getAllItems() {
      const response = await fetch(`${API_BASE_URL}/items`);
      return response.json();
    }
  };
  
  export default apiService;